import React from 'react';
import { QualitySelector } from './QualitySelector';
import logo from '../../assets/logo.png';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export const PlaylistView = ({ playlist, quality, setQuality, onDownloadItem, loading }) => {
    return (
        <div className="playlist-card fade-in">
            <div className="playlist-header">
                <div className="playlist-header-info">
                    <h2>{playlist.title || 'Playlist'}</h2>
                    <p>{playlist.entries?.length || 0} videos found • {playlist.uploader || 'Unknown Uploader'}</p>
                </div>
                <div className="format-row playlist-quality-control">
                    <label htmlFor="playlistVideoQuality">Quality</label>
                    <QualitySelector
                        id="playlistVideoQuality"
                        type="video"
                        value={quality}
                        onChange={(e) => setQuality(e.target.value)}
                    />
                </div>
            </div>
            <div className="playlist-grid">
                {(playlist.entries || []).map((video) => (
                    <div key={video.id} className="playlist-item">
                        <div className="history-thumb" style={{ width: '120px', height: '68px' }}>
                            <img
                                src={video.thumbnail || logo}
                                alt={video.title}
                                onError={(e) => {
                                    if (video.thumbnail && !e.target.src.includes('image-proxy')) {
                                        e.target.src = `${API_BASE}/api/image-proxy?url=${encodeURIComponent(video.thumbnail)}`;
                                    }
                                }}
                            />
                        </div>
                        <div className="playlist-item-info">
                            <h3>{video.title}</h3>
                            <p>{video.duration ? `${Math.floor(video.duration / 60)}:${(video.duration % 60).toString().padStart(2, '0')}` : ''}</p>
                        </div>
                        <button
                            onClick={() => onDownloadItem(video.url, quality)}
                            disabled={loading}
                        >
                            Download
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};
